export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10276.4f822c1f.jpg";